import HomeAbout from "components/HomeAbout";
// import HomeCatalogue from "components/HomeCatalogue";
import HomeHero from "components/HomeHero";
import HomeProjectShowcase from "components/HomeProjectShowcase";
import HomeWholesale from "components/HomeWholesale";

function HomePage() {
  return (
    <>
      <HomeHero />
      {/* <HomeCatalogue /> */}
      <HomeWholesale />
      <HomeAbout />
      <HomeProjectShowcase />
    </>
  );
}

export default HomePage;
